import React from 'react';
import type {
  EmergencyConfigurationOnAzure,
  UpdateEmergencyConfigRequest,
} from '@/../generated-client/models';
import { EmergencyConfigModalBase } from './EmergencyConfigModalBase';

interface Props {
  show: boolean;
  onHide: () => void;
  config: EmergencyConfigurationOnAzure;
  onUpdate: (updated: UpdateEmergencyConfigRequest) => void;
}

export const EditEmergencyConfigModal: React.FC<Props> = ({ show, onHide, config, onUpdate }) => {
  return (
    <EmergencyConfigModalBase
      show={show}
      onHide={onHide}
      config={config}
      onSave={onUpdate}
      mode="edit"
    />
  );
};
